import React from "react";
import { AboutPGLI } from "./AboutPGLI";

import { BenefitInsuranceTemplate } from "../../../types";
import { PGLI_KEY, PLAN_DETAILS } from "../../../utils/constants";

const {
  monthlyPremiumFormatted,
  initiationFeeFormatted,
  monthlyPremium,
  initiationFee,
  name
} = PLAN_DETAILS[PGLI_KEY];

export const getPGLIBenefitDetails = (): BenefitInsuranceTemplate => {
  return {
    slug: PGLI_KEY,
    title: name,
    costDescription: (
      <>
        <b>Monthly Premium:</b> {monthlyPremiumFormatted} per month.
        <br /> <br />
        <b>Initiation Fee:</b> A one-time {initiationFeeFormatted} fee is
        charged upon first-time enrollment.
      </>
    ),
    about: <AboutPGLI />
  };
};
